/**
 * Test IDs for QA automation.
 */
export const testIds = {
  autoPlanModalClose: "auto-plan-modal-close",
  autoPlanModalConfirm: "auto-plan-modal-confirm",
} as const;
